import { useTranslation } from "react-i18next";
import styled from "styled-components";

const VIDEO_POSTER = "https://studtur.rudn.ru/files/IBz5eLJdeu-faf3eb4446fd8b1ab50ab5608d4497aa723ef84c19f233c61a999c2591ffb21f.jpg";

const IntensivePage = () => {
    const { i18n } = useTranslation();
    const isRu = i18n.language === "ru";

    return (
        <OuterWrapper>
            <Wrapper>
                <Heading>
                    {isRu ? "Интенсив по работе с платформой" : "Platform Training Intensive"}
                </Heading>
                <Description>
                    {isRu
                        ? "Образовательный интенсив по работе с платформой студтуризм.рф поможет её пользователям познакомиться с возможностями информационного ресурса и узнать алгоритмы действий, которые можно совершать на сайте. После просмотра данного интенсива использование платформы станет удобнее и легче."
                        : "The educational intensive on working with the studtourism.rf platform will help its users get acquainted with the capabilities of the information resource and learn the algorithms of actions that can be performed on the site. After watching this intensive, using the platform will become more convenient and easier."}
                </Description>

                {/* Амбассадор и МедиаАмбассадор Программы Студтуризм */}
                <SectionTitle>Амбассадор и МедиаАмбассадор Программы Студтуризм</SectionTitle>

                <VideoSection>
                    <VideoTitle>1. Профиль Амбассадоры</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/ambassador_profile.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/ambassador_profile.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>2. Новости Амбассадоры</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/ambassador_news.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/ambassador_news.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                {/* Оргкомитет Программы Студтуризм */}
                <SectionTitle>Оргкомитет Программы Студтуризм</SectionTitle>

                <VideoSection>
                    <VideoTitle>1. Вход в лк вуза</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_login.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_login.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>2. Работа с общежитиями</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_dormitories.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_dormitories.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>3. Обработка заявок на проживание</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_accommodation_requests.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_accommodation_requests.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>4. Работа с событиями</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_events.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_events.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>5. Обработка заявок на события</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_event_requests.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_event_requests.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>6. Студтурклубы</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_student_clubs.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_student_clubs.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>7. Объекты научной инфраструктуры</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_research_facilities.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_research_facilities.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>8. Дополнительные возможности оргкомитетов</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/orgcommittee_additional_features.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/orgcommittee_additional_features.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                {/* Участник Программы Студтуризм */}
                <SectionTitle>Участник Программы Студтуризм</SectionTitle>

                <VideoSection>
                    <VideoTitle>1. Регистрация участника ПС</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/participant_registration.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/participant_registration.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>2. Бронирование проживания</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/participant_accommodation_booking.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/participant_accommodation_booking.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>3. Заявка на событие</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/participant_event_application.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/participant_event_application.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>4. Уведомления и бот</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/participant_notifications_bot.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/participant_notifications_bot.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>5. Поиск Амбассадора и МедиаАмбассадора</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/participant_find_ambassador.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/participant_find_ambassador.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

                <VideoSection>
                    <VideoTitle>6. Остальные возможности платформы</VideoTitle>
                    <StyledVideo controls poster={VIDEO_POSTER}>
                        <source src="https://studtur.rudn.ru/files/participant_other_features.mp4" type="video/mp4" />
                        Ваш браузер не поддерживает видео. <a href="https://studtur.rudn.ru/files/participant_other_features.mp4">Скачать видео</a>
                    </StyledVideo>
                </VideoSection>

            </Wrapper>
        </OuterWrapper>
    );
};

const OuterWrapper = styled.div`
    width: 100%;
    background: white;
    padding-top: 30px;
    box-sizing: border-box;
    padding-bottom: 80px;
    flex: 1;
`;

const Wrapper = styled.div`
    text-align: left;
    box-sizing: border-box;
    width: 1400px;
    margin: 0 auto;
    padding: 15px;
    @media (max-width: 1400px) {
        width: 100%;
    }
`;

const Heading = styled.h1`
    font-family: "Noto Sans", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 52px;
    margin-bottom: 20px;
    @media (max-width: 820px) {
        font-size: 28px;
        line-height: 36px;
    }
`;

const Description = styled.p`
    font-family: "Noto Sans", sans-serif;
    font-size: 18px;
    line-height: 28px;
    color: #555;
    margin-bottom: 40px;
    max-width: 900px;
    @media (max-width: 820px) {
        font-size: 16px;
        line-height: 24px;
    }
`;

const SectionTitle = styled.h2`
    font-family: "Noto Sans", sans-serif;
    font-size: 28px;
    line-height: 36px;
    font-weight: 600;
    margin-top: 50px;
    margin-bottom: 30px;
    padding-bottom: 10px;
    border-bottom: 2px solid #02BF89;
    @media (max-width: 820px) {
        font-size: 22px;
        line-height: 28px;
    }
`;

const VideoSection = styled.div`
    margin-bottom: 40px;
`;

const VideoTitle = styled.h3`
    font-family: "Noto Sans", sans-serif;
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    color: #333;
    margin-bottom: 15px;
    @media (max-width: 820px) {
        font-size: 18px;
        line-height: 24px;
    }
`;

const StyledVideo = styled.video`
    width: 100%;
    max-width: 800px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

export default IntensivePage;
